export const getVoucherOrderId = (orderData) => {
  const id = orderData?.order?.id ?? orderData?.id;
  return typeof id === "string" && id.trim() ? id.trim()
    : typeof id === "number" && Number.isFinite(id) ? String(id) : null;
};

export const getVoucherOrderInfo = (response) => {
  const candidates = [response?.data?.data, response?.data, response];
  const info = candidates.find((candidate) => getVoucherOrderId(candidate));
  if (!info) return null;
  return info.order ? info : { order: info };
};

// The cart supports both one entry per voucher and legacy grouped quantities.
export const buildVoucherOrderItems = (vouchers) => {
  const items = new Map();
  vouchers.forEach((voucher) => {
    const key = String(voucher.id);
    const item = items.get(key) || { product_id: voucher.id, occurrences: 0, maxCount: 0 };
    item.occurrences += 1;
    item.maxCount = Math.max(item.maxCount, Number(voucher.count) || 1);
    items.set(key, item);
  });
  return Array.from(items.values(), (item) => ({
    product_id: item.product_id,
    quantity: Math.max(item.occurrences, item.maxCount),
  }));
};
